/* eslint-disable no-unused-vars */
import React from "react";
import { Link } from "react-router-dom";
import { Dropdown, Navbar, Nav, Offcanvas } from "react-bootstrap";
import Logo from "../../assets/logo.webp";

import MenuIcon from "@iconscout/react-unicons/icons/uil-bars";
import { useDispatch } from "react-redux";

import actions from "../../redux/actions/userAction";

const DashboardHeader = () => {
  const dispatch = useDispatch();
  return (
    <header className="dashboard-header">
      <Navbar expand="lg">
        <div className="container" style={{ display: "block" }}>
          <div className="navigation">
            <div className="left-navigation">
              <div className="logo-box">
                <Link to="/landing-page">
                  <img src={Logo} className="header-logo" alt="Company Logo" />
                </Link>
              </div>
              <Navbar.Toggle aria-controls="responsive-navbar-nav">
                <MenuIcon color="#FFF" size="25" />
              </Navbar.Toggle>
              <Navbar.Offcanvas
                id="responsive-navbar-nav"
                className="mobile-menu"
              >
                <Offcanvas.Header className="mobile-menu-header" closeButton>
                  <img src={Logo} className="header-logo" alt="Company Logo" />
                </Offcanvas.Header>
                <Offcanvas.Body className="mobile-menu-body">
                  <Nav className="navigation-options">
                    <Nav.Link
                      href="/landing-page"
                      className="navigation-item"
                      active={
                        window.location.pathname === "/landing-page"
                          ? true
                          : false
                      }
                    >
                      Homepage
                    </Nav.Link>
                    <Nav.Link
                      href="/mom-me"
                      className="navigation-item"
                      active={
                        window.location.pathname === "/mom-me" ? true : false
                      }
                    >
                      Mom and Me
                    </Nav.Link>
                    <Nav.Link
                      href="/kathak-certification"
                      className="navigation-item"
                      active={
                        window.location.pathname === "/kathak-certification"
                          ? true
                          : false
                      }
                    >
                      Kathak Certification
                    </Nav.Link>
                    {/* <Nav.Link
                      href="/yog-garba"
                      className="navigation-item"
                      active={
                        window.location.pathname === "/yog-garba" ? true : false
                      }
                    >
                      YoG Garba Leads
                    </Nav.Link> */}
                    <Nav.Link
                      href="/contact-us"
                      className="navigation-item"
                      active={
                        window.location.pathname === "/contact-us"
                          ? true
                          : false
                      }
                    >
                      General Inquiries
                    </Nav.Link>
                    <Nav.Link
                      href="/subscription"
                      className="navigation-item"
                      active={
                        window.location.pathname === "/subscription"
                          ? true
                          : false
                      }
                    >
                      Yog Garba Leads
                    </Nav.Link>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </div>
            {/* RIGHT NAVIGATION */}
            <div className="right-navigation">
              <Dropdown className="profile-dropdown">
                <Dropdown.Toggle>
                  <div className="profile-avatar">
                    <div className="admin-details">
                      <p>Administrator</p>
                      <h5>Anjali KP</h5>
                    </div>
                    <img
                      src={require("../../assets/logo.webp")}
                      alt="Profile"
                    />
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="profile-dropdown-menu">
                  <Dropdown.Item
                    href="/"
                    onClick={() => {
                      dispatch(actions.setLoggedIn(false));
                      dispatch(actions.setToken(null));
                      dispatch(actions.setLoggedIn(false));
                      dispatch(actions.setUser(null));
                    }}
                    className="menu-item"
                  >
                    Log out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </Navbar>
    </header>
  );
};

export default DashboardHeader;
